import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

class Input extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      inputStr: null,
    };

    this.refEl = React.createRef();

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  get charCount() {
    const {base, max} = this.props;
    if (base === 10) return 0;
    const maxStr = this._format(max);
    return maxStr.length;
  }

  get strVal() {
    if (this.state.inputStr != null) return this.state.inputStr;
    return this.format(this.props.value || 0);
  }

  parse(inputStr) {
    const {min, max, base} = this.props;
    let num = parseInt(inputStr, base);
    if (!Number.isFinite(num)) return min;
    if (num < min) return min;
    if (num > max) return max;
    return num;
  }

  _format(num) {
    return num.toString(this.props.base).toUpperCase();
  }

  format(num) {
    return _.padStart(this._format(num), this.charCount, '0');
  }

  onChange(event) {
    const inputStr = event.target.value;
    this.setState({inputStr});
    this.props.onChange(this.parse(inputStr));
  }

  onBlur() {
    this.setState({inputStr: null});
  }

  onFocus() {
    const el = this.refEl.current;
    if (!el) return;
    el.select();
  }

  render() {
    return (
      <input ref={this.refEl} className={this.props.className} type="text" value={this.strVal} onChange={this.onChange} onBlur={this.onBlur} onFocus={this.onFocus} placeholder={this.format(this.props.max)} />
    );
  }

}

Input.propTypes = {
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  base: PropTypes.number,
};

Input.defaultProps = {
  className: '',
  min: 0,
  max: 255,
  base: 16,
};

export default Input;
